import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser, refresh } = useAuth();
    const processed = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = location.hash || window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");
        if (!session_id) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const data = await authApi.createSession(session_id);
                // Populate AuthContext immediately so ProtectedLayout sees the user
                if (data) setUser(data);
                // clean URL
                window.history.replaceState({}, document.title, "/dashboard");
                // verify cookie + sync server state in the background (non-blocking)
                refresh().catch(() => {});
                navigate("/dashboard", { replace: true });
            } catch (e) {
                console.error("OAuth callback failed:", e);
                if (e?.response?.status === 403) {
                    navigate("/unauthorized", { replace: true });
                    return;
                }
                setError("Sign-in failed. Please try again.");
                setTimeout(() => navigate("/", { replace: true }), 2500);
            }
        })();
    }, [location, navigate, setUser, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center parchment grain" data-testid="auth-callback">
            <div className="text-center max-w-sm">
                <div className="inline-block w-3 h-3 rounded-full bg-primary animate-pulse mb-3" />
                <div className="font-serif text-2xl mb-2">Signing you in…</div>
                <div className="text-sm text-muted-foreground">{error || "Establishing your secure session."}</div>
            </div>
        </div>
    );
}
